var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file","name":"file","accept":_vm.upload.accept},on:{"change":_vm.upFile}})}
var staticRenderFns = []

export { render, staticRenderFns }